module.exports = __webpack_public_path__ + "images/organization/missing.930abc84ebe27331d32a.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/organization/missing.svg
// module id = uCy/
// module chunks = 2